import { combineReducers } from '@reduxjs/toolkit';
import navigationReducer from './navigationSlice';
import filtersReducer from './filtersSlice';
import searchReducer from './searchSlice';
import trcReducer from './trcSlice';

const rootReducer = combineReducers({
  navigation: navigationReducer,
  filters: filtersReducer,
  search: searchReducer,
  trc: trcReducer,
});

export default rootReducer;
